import { Box, Grid, Typography, IconButton } from "@material-ui/core";

import { CX_SCORE_VAL } from "../../entity/entities";
import { QUESTION_TYPE_ATTR_SELECT_SCORE } from "../../constant/Enum";
import { colorUtil } from "../../util/ColorUtil";

import { StarIcon, HeartIcon, CircleIcon } from "../icons";

const { HEART, STAR, CIRCLE } = QUESTION_TYPE_ATTR_SELECT_SCORE;

export const RatingScore = (props: {
  scoreWidth: string | number;
  iconWidth: string | number;
  iconHeight: string | number;
  score: number | null;
  questionTypeAttr: string;
  handleIconClick: (score: CX_SCORE_VAL) => void;
  maxScore?: number;
}) => {
  const {
    scoreWidth,
    iconWidth,
    iconHeight,
    questionTypeAttr,
    score = 0,
    handleIconClick,
    maxScore = 5,
  } = props;
  const iconScores: CX_SCORE_VAL[] = [];

  for (let score = 1; score <= maxScore; score += 1) {
    iconScores.push(score as CX_SCORE_VAL);
  }

  return (
    <Grid container>
      {iconScores.map((iconScore, index) => {
        return (
          <Box
            key={iconScore}
            textAlign="center"
            style={{
              width: `${scoreWidth}%`,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              component="span"
              style={{
                fontWeight: "bold",
                fontSize: "18px",
                color: colorUtil.gray75,
              }}
            >
              {iconScore}
            </Typography>
            <IconButton
              style={{
                width: iconWidth,
                height: iconHeight,
                padding: "0",
              }}
              onClick={() => handleIconClick(iconScore)}
            >
              {questionTypeAttr === STAR && (
                <StarIcon
                  width="100%"
                  height="100%"
                  isSelected={score !== null && score >= iconScore}
                />
              )}
              {questionTypeAttr === HEART && (
                <HeartIcon
                  width="100%"
                  height="100%"
                  isSelected={score !== null && score >= iconScore}
                />
              )}

              {questionTypeAttr === CIRCLE && (
                <CircleIcon
                  width="100%"
                  height="100%"
                  isSelected={score !== null && score >= iconScore}
                />
              )}
            </IconButton>
          </Box>
        );
      })}
    </Grid>
  );
};
